var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header flex-center-space-between" }, [
      _c("span", [_vm._v("Livraisons prévues")]),
      _vm.inventaireOuvert
        ? _c("span", { staticClass: "text-warning" }, [
            _c("i", {
              staticClass: "fas fa-exclamation-triangle text-warning"
            }),
            _vm._v(" Inventaire en cours : Contrôle à réception verrouillé ")
          ])
        : _vm._e(),
      _c("span")
    ]),
    _c("div", { staticClass: "card-container" }, [
      !_vm.gotLivraisons
        ? _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "40px" } },
            [
              _c("img", {
                staticStyle: { height: "100px", "margin-left": "-8px" },
                attrs: {
                  alt: "en attente",
                  src: "/assets/images/spinners/cooking-blue-court.gif"
                }
              })
            ]
          )
        : _c("div", [
            _c("h2", { staticClass: "text-center mt-2" }, [
              _c("b", [_vm._v(_vm._s(_vm.nombreLivraisons))])
            ]),
            _c("div", { staticClass: "text-center" }, [
              _c("b", [
                _vm._v(
                  "livraison" +
                    _vm._s(_vm.livraisons.length > 1 ? "s" : "") +
                    " prévue" +
                    _vm._s(_vm.livraisons.length > 1 ? "s" : "")
                )
              ])
            ]),
            _vm._m(0),
            _c(
              "div",
              {
                staticClass:
                  "card card-minimal table-scroll height-responsive-inner-top-50 mt-4"
              },
              [
                _vm._m(1),
                _c("hr", { staticClass: "mt-0 mb-0" }),
                _c("div", { staticClass: "table-body" }, [
                  _c(
                    "table",
                    {
                      staticClass: "table table-sm table-borderless text-center"
                    },
                    [
                      _vm._m(2),
                      _c(
                        "tbody",
                        [
                          _vm.livraisons.some(function(l) {
                            return (
                              _vm.formatDateAvecTirets(l.dateLivraison) ===
                              _vm.formatDateAvecTirets(new Date())
                            )
                          })
                            ? _c("tr", [
                                _c("td", { attrs: { colspan: "7" } }, [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.formatHumanDate(new Date()))
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._l(
                            _vm.livraisons.filter(function(l) {
                              return (
                                _vm.formatDateAvecTirets(l.dateLivraison) ===
                                _vm.formatDateAvecTirets(new Date())
                              )
                            }),
                            function(livraison, iLivraison) {
                              return _c("tr", { key: iLivraison }, [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-200-xl"
                                  },
                                  [_vm._v(_vm._s(livraison.fournisseur))]
                                ),
                                _c("td", [
                                  _vm._v(_vm._s(livraison.nomCommande))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(livraison.bonDeCommande))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(livraison.produits) + " ("),
                                  _c("em", [_vm._v(_vm._s(livraison.fCodes))]),
                                  _vm._v(")")
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("afficherPrix2")(livraison.totalHT)
                                    )
                                  )
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "input" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: {
                                          disabled: _vm.inventaireOuvert,
                                          title: "Réceptionner la commande"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              name: "DetailCommandeFournisseur",
                                              params: {
                                                etablissementId:
                                                  _vm.etabCourantId,
                                                commandeId:
                                                  livraison.commandeId,
                                                fournisseurId:
                                                  livraison.fournisseurId
                                              }
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-dolly-flatbed"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            }
                          ),
                          _vm.livraisons.some(function(l) {
                            return (
                              _vm.formatDateAvecTirets(l.dateLivraison) ===
                              _vm.formatDateAvecTirets(_vm.demain())
                            )
                          })
                            ? _c("tr", [
                                _c("td", { attrs: { colspan: "7" } }, [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.formatHumanDate(_vm.demain()))
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._l(
                            _vm.livraisons.filter(function(l) {
                              return (
                                _vm.formatDateAvecTirets(l.dateLivraison) ===
                                _vm.formatDateAvecTirets(_vm.demain())
                              )
                            }),
                            function(livraison, iLivraisonDemain) {
                              return _c(
                                "tr",
                                { key: "demain" + iLivraisonDemain },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-200-xl"
                                    },
                                    [_vm._v(_vm._s(livraison.fournisseur))]
                                  ),
                                  _c("td", [
                                    _vm._v(_vm._s(livraison.nomCommande))
                                  ]),
                                  _c("td", [
                                    _vm._v(_vm._s(livraison.bonDeCommande))
                                  ]),
                                  _c("td", [
                                    _vm._v(_vm._s(livraison.produits) + " ("),
                                    _c("em", [
                                      _vm._v(_vm._s(livraison.fCodes))
                                    ]),
                                    _vm._v(")")
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("afficherPrix2")(
                                          livraison.totalHT
                                        )
                                      )
                                    )
                                  ]),
                                  _c("td")
                                ]
                              )
                            }
                          )
                        ],
                        2
                      )
                    ]
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "text-center mt-2 mb-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: !_vm.profilIsUtilisateur },
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          name: "ListeDesCommandes",
                          params: { etablissementId: _vm.etabCourantId }
                        })
                      }
                    }
                  },
                  [_vm._v("Voir plus de détails")]
                )
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("b", [_vm._v("entre aujourd'hui et demain")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "table table-sm table-borderless text-center" },
      [
        _c("colgroup", [
          _c("col"),
          _c("col"),
          _c("col", { attrs: { width: "120" } }),
          _c("col", { attrs: { width: "120" } }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "35" } })
        ]),
        _c("thead", [
          _c(
            "th",
            {
              staticClass:
                "col-fixed-width-150-sm col-fixed-width-200-lg col-fixed-width-200-xl"
            },
            [_vm._v("Fournisseurs")]
          ),
          _c("th", [_vm._v("Commandes")]),
          _c("th", [_vm._v("N° BdC")]),
          _c("th", [
            _vm._v("produits ("),
            _c("em", [_vm._v("fam.")]),
            _vm._v(")")
          ]),
          _c("th", [_vm._v("Total HT")]),
          _c("th")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col"),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "120" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "30" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }